import { workflowsDataSelector } from "./workflowsDataSelector";
import { RootState } from "../../../../store";

export const workflowsExistSelector = (state: RootState): boolean => {
  const schedules = workflowsDataSelector(state);

  return !!schedules?.length;
};
